export default __webpack_public_path__ + "static/media/kone-logo-with-text.31acd51e.png";